export var AMOUNT_TYPE;
(function (AMOUNT_TYPE) {
  AMOUNT_TYPE["ONCE_OFF"] = "ONCE_OFF";
  AMOUNT_TYPE["RECURRING"] = "RECURRING";
})(AMOUNT_TYPE || (AMOUNT_TYPE = {}));